export const SENT_FAX_FOLDER = 'sent-fax'
export const RECEIVED_FAX_FOLDER = 'received-fax'
export const FAX_SENT_COLLECTION = 'fax-sent'
export const FAX_RECEIVED_COLLECTION = 'fax-received'
